export default "/images/cross.png?607de2c43315b789f9fe407f38770043";